// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__Vz-Jr","content":"Consent_content__3yyIb","footer":"Consent_footer__3M6fS"};